import parseClassNames from 'classnames'
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'

type PropType = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

const BaseButton = (props: PropType) => {
  return (
    <button
      {...props}
      className={parseClassNames(
        'min-h-14 rounded-1 font-semibold text-sm cursor-pointer disabled:cursor-not-allowed',
        props.className || ''
      )}
    />
  )
}

export default BaseButton
